export enum TestId {
  // Navigation
  CONTINUE_BUTTON = "continue-button",
  BACK_BUTTON = "back-button",
  SKIP_BUTTON = "skip-button",
  // Page Section
  PAGE_TITLE_H1 = "page-title-h1",
  PAGE_SUBTITLE = "page-subtitle",
  // Notification
  NOTIFICATION_MESSAGE = "notification-message",
  // Form Fields
  FORM_FIELD_ERROR_MESSAGE = "form-field-error-message",
  // Uncontrolled Select
  UNCONTROLLED_SELECT_LIST = "uncontrolled-select-list",
}
